import OtpLoginForm from "../../components/auth/OtpLoginForm";
import sakhi_login_illustration from "../../Assets/Images/Login/sakhi_login_illustration.png";

const Login = () => {
  return (
    <div className="min-h-screen max-h-screen relative flex items-center justify-center overflow-hidden lg:bg-gradient-to-br lg:from-[#F7BFAD]/40 lg:via-white lg:to-[#f6b09a]/40">
      {/* MOBILE BACKGROUND IMAGE */}
      <div className="absolute inset-0 lg:hidden">
        <img
          src={sakhi_login_illustration}
          alt="Login background"
          className="w-full h-full object-cover"
        />
        {/* Overlay */}
        <div className="absolute inset-0 bg-black/30 backdrop-blur-[2px]" />
      </div>

      {/* FLOATING CONTAINER */}
      <div className="relative z-10 w-full h-full lg:w-[80%] lg:h-[80%] lg:bg-white lg:rounded-3xl lg:shadow-[0_30px_80px_rgba(0,0,0,0.25)] lg:overflow-hidden flex items-center justify-center">
        {/* DESKTOP GRID */}
        <div className="hidden lg:grid grid-cols-2 h-full w-full">
          {/* LEFT IMAGE */}
          <div className="flex items-center justify-center bg-[#F7BFAD]/30">
            <img
              src={sakhi_login_illustration}
              alt="Sakhi Login Illustration"
              className="h-full object-cover"
            />
          </div>

          {/* RIGHT FORM */}
          <div className="flex items-center justify-center bg-gradient-to-br from-brandAccentColor/30 via-white to-brandAccentColor/70">
            <div className="max-w-md w-full px-10">
              <OtpLoginForm />
            </div>
          </div>
        </div>

        {/* MOBILE OVERLAY */}
        <div className="absolute inset-0 bg-black/80 lg:hidden"></div>

        {/* MOBILE FLOATING FORM */}
        <div className="absolute lg:hidden w-[80%] max-w-[27rem] bg-white/50 backdrop-blur-xl ring-1 ring-accentTextColor rounded-xl py-4 lg:py-8  px-3 lg:px-5 left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 flex flex-col ">
          <OtpLoginForm />
        </div>
      </div>
    </div>
  );
};

export default Login;

// import sakhi_login_illustration from "../../Assets/Images/Login/sakhi_login_illustration.png";
// import LoginForm from "../../components/auth/LoginForm";
// import OtpLoginForm from "../../components/auth/OtpLoginForm";

// const Login = () => {
//   return (
//     <div className="min-h-screen flex items-center justify-center lg:bg-gradient-to-br lg:from-[#F7BFAD]/40 lg:via-white lg:to-[#f6b09a]/40">
//       {/* FLOATING MODAL */}
//       <div className=" relative w-[90%] h-[90%] lg:w-[80%] lg:h-[80%] lg:bg-white lg:rounded-3xl lg:shadow-[0_30px_80px_rgba(0,0,0,0.25)] lg:overflow-hidden ">
//         {/* GRID INSIDE MODAL */}
//         <div className="grid grid-cols-1 lg:grid-cols-2 h-full">
//           {/* LEFT COLUMN */}
//           <div className="hidden lg:flex items-center justify-center bg-[#F7BFAD]/30">
//             <img
//               src={sakhi_login_illustration}
//               alt="Sakhi Login Illustration"
//               className="h-full object-cover"
//             />
//           </div>

//           {/* RIGHT COLUMN */}
//           <div className="flex items-center max-w-md lg:max-w-full justify-center  w-full mx-auto sm:px-10 rounded-xl lg:rounded-none shadow-xl lg:shadow-none bg-gradient-to-br from-brandAccentColor/30 via-white to-brandAccentColor/70">
//             {/* <LoginForm /> */}
//             <OtpLoginForm />
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Login;
